import React, { PureComponent } from "react";
import styles from "./Sidebar.local.scss";

import AuthorsComponent from "../../Common/Authors/AuthorsComponent";
import SocialContainer from "../../Common/Social/SocialContainer";
import Comments from "../Comments";

import classnames from "classnames";

import { getDateLabel } from "Utils";

export default class Sidebar extends PureComponent {
  render() {
    const { currentResource, type } = this.props;

    if (!currentResource) {
      return null;
    }
    const { author, publishedAt, creator, isExternal } = currentResource;

    let helpUser =
      isExternal && creator ? [{ ...creator, enableAvatar: true }] : [];
    if (!isExternal && author) {
      helpUser = author;
    }

    return (
      <div className={styles.sidebar}>
        <div className={classnames("grid-x", styles.authors)}>
          <AuthorsComponent
            authors={helpUser ? helpUser : []}
            fromViewer={true}
          />
          <div className={styles.date}>
            <span>{getDateLabel(publishedAt).split(",")[0]}</span>
            <span>{getDateLabel(publishedAt).split(",")[1]}</span>
          </div>
        </div>
        <SocialContainer
          resource={currentResource}
          fromViewer={true}
          type={type}
        />
        <Comments currentResource={currentResource} type={type} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/Sidebar/index.js